var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bng-virtual-sport-game"},[(_vm.jackpots && _vm.jackpots.length)?_c('jackpots-bar'):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/virtual-sports/virtual-sport-game/virtual-sport-game.vue?vue&type=template&id=4c3cbb70
// module id = E+IE
// module chunks = 0